import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import { map } from 'rxjs';

import { TranslatePipe } from '@camelot/translation';
import { PwaComponent, TitleComponent, UserLogoComponent } from '@camelot/ui';

import { BasePage } from '../../../core/abstract/base-page';
import { LayoutContentComponent } from '../../../core/layout/layout-content/layout-content.component';
import { LayoutFirstLevelComponent } from '../../../core/layout/layout-first-level/layout-first-level.component';
import { LayoutTitleComponent } from '../../../core/layout/layout-title/layout-title.component';
import { DashboardInvoiceComponent } from '../../components/dashboard-invoice/dashboard-invoice.component';
import { DashboardProjectComponent } from '../../components/dashboard-project/dashboard-project.component';
import { DashboardQuotationComponent } from '../../components/dashboard-quotation/dashboard-quotation.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  imports: [
    CommonModule,
    DashboardInvoiceComponent,
    LayoutContentComponent,
    LayoutFirstLevelComponent,
    LayoutTitleComponent,
    DashboardProjectComponent,
    PwaComponent,
    DashboardQuotationComponent,
    TitleComponent,
    TranslatePipe,
    UserLogoComponent,
  ],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomePage extends BasePage {
  public readonly profileName$ = this._usersService.currentUser.get$().pipe(
    map(user => ({
      profilePictureUrl: user?.picture,
      naming: {
        firstName: user?.firstName || '',
        name: user?.lastName || '',
        trigram: user?.trigram || '',
      },
    }))
  );
}
